@if (!loading) {
  <div class="select">
    <select (change)="addOfficerFilter($event)" [value]="SelectedOfficerId">
      <option value="all" selected>All Officers</option>
      @for (officer of Officers; track officer) {
        <option [value]="officer.Id">
          {{officer.UserName}}
        </option>
      }
    </select>
  </div>
}
@if (loading) {
  <div class="select">
    <select disabled>
      <option>Loading Officers...</option>
    </select>
  </div>
}

